<template>
    <div class="container" style="padding-right: 400px;">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill border text-dark p-2 px-3">
                  <b>Users Group : แผนก</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
              <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#UsergroupModal" @click="newRecord()" style="width:160px;">New</button>
              <!-- <div class="col float-end "> <input class="btn btn-primary" value="New" @click="newRecord()"></div> -->
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myUsergroupTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:black">
                <tr>
                    <th>รหัส</th>
                    <th>ชื่อแผนก</th>
                    <th>คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.UsergroupID" v-bind:data-id="item.UsergroupID" @click="tableChanged(item)">
                    <!-- <td class="text-start">{{ item.ReqClinicCode }}</td> -->
                    <td class="text-start">{{ item.UsergroupCode }}</td>
                    <td class="text-start">{{ item.UsergroupName }}</td>
                    <td  >
                        <button type="button" class="btn btn-primary btn-sm mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#UsergroupModal">Edit</button>
                        <button class="btn btn-danger btn-sm " id="Delete" @click="cancelRecord(item)">Del</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal Form -->
        <div id="UsergroupModal" class="modal" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">User group : ป้อนข้อมูลแผนก</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form id="fmUsergroup" @submit.prevent="" >
                    <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                    <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                    <input type="text" hidden class="form-control" placeholder="" name="id" v-model="curRecord.UsergroupID" >
                    <div class="row mb-2">
                        <div class="col-4 text-start">
                            <label for="code" class="mr-sm-2">รหัส:</label>
                            <input type="text" class="form-control" id="code" placeholder="รหัส*" name="code" autocomplete="off" v-model="curRecord.UsergroupCode" required>
                        </div>
                        <div class="col-8 text-start">
                            <label for="name" class="mr-sm-2 ">ชื่อแผนก:</label>
                            <input type="text" class="form-control" id="name"  placeholder="ชื่อ*" name="name" autocomplete="off" v-model="curRecord.UsergroupName" required>
                        </div>
                    </div>
                    <br>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Specimens',
  components: {

  },
  data () {
    return {
      datalists: null,
      // provinceRows: [],
      curRecord: {},
      action: 'new'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.Name,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_usergroup.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_specimen.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_specimen.php',
            data: { id: item.UsergroupID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.getData()
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    getData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/usergroup_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myUsergroupTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmUsergroup').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_usergroup.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            self.getData()
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>

<style>

</style>
